import { render, staticRenderFns } from "./CommunityProjectHome.vue?vue&type=template&id=a90ae0aa&scoped=true&"
import script from "./CommunityProjectHome.vue?vue&type=script&lang=js&"
export * from "./CommunityProjectHome.vue?vue&type=script&lang=js&"
import style0 from "./CommunityProjectHome.vue?vue&type=style&index=0&id=a90ae0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ae0aa",
  null
  
)

export default component.exports